import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import moment from "moment";
import classNames from "classnames";

import { compose } from "recompose";
import { withSnackbar } from "notistack";

import { Button } from "@material-ui/core";
import { Marker, Popup } from "react-leaflet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAt, faBuilding, faHouseChimney, faInfoCircle } from "@fortawesome/free-solid-svg-icons";

import { DivIcon } from "../../../../components";
import { baseIcon, IconImb, IconPavillon, IconAt } from "../icons";
import { colorIcons, couleurZaDeploiement } from "../../../../enums";

import { Immeuble } from "../../../../services";
import "./MarkersImbDsp.scss";

const MarkersImbFtth = ({
  dsp,
  imbWkt,
  marcheList,
  optionSelectedConfigCarte,
  isMobileLandscape,
  displayMarkerImb,
  setChargementIMBWtk,
  onMarkerImbClick,
  onOperatorPopupClick,
  enqueueSnackbar,
}) => {
  const [markersImmeubles, setMarkersImmeubles] = useState([]);
  const [abortImbWkt, setAbortImbWkt] = useState(new AbortController());

  /*
    STATUT IMMEUBLE                     | CODE STATUT
                                        |
    RA : Raccordé                       | RA : Raccordé
    DE : Déployé && MeS < today         | EL : Eligible
    GE : Déployé && MeS > today         | PE : Prochainement Eligible
    CI : Ciblé                          | GE : Correction technique en cours (Gel Commercial)
    SI : Signé                          | RDEC : Raccordement demandé en cours de déploiement
    EC : En cours de déploiement        | RD : Raccordable sur demande
    RD : Raccordable sur demande        | ET : En cours d'étude
    ET : En cours d'étude               |
    --------------------------------------------------------------------------------
    ETAPE CONSTRUCTION

    BCT : Bloc collectif tiers          | BCT : Bloc collectif tiers 
  */

  // Récupère les immeubles pour une zone géographique
  const getImmeublesWTK = async (minLatLng, maxLatLng) => {
    setChargementIMBWtk(true);

    abortImbWkt.abort();
    const abort = new AbortController();
    setAbortImbWkt(abort);

    Immeuble.getImmeublesFtthWkt(minLatLng.lng, minLatLng.lat, maxLatLng.lng, maxLatLng.lat, abort)
      .then(responseImbsFtth => {
        const currentYear = moment().year();
        const markersImmeublesTemp = responseImbsFtth.features
          .filter(
            imb =>
              marcheList.map(e => e.codeReseau).includes(imb.properties.codeReseau) &&
              imb.properties.statutEligibilite !== "AB",
          )
          .map(item => {
            const itemProps = { ...item.properties };
            let statutElig = "";
            let codeStatut = "";
            let iconColor = "";
            let zaColor = "";

            if (itemProps.gelCommercial === "1") {
              statutElig = "Correction technique en cours";
              codeStatut = "GE";
              iconColor = colorIcons.gelCommercial;
            } else if (itemProps.statutEligibilite === "RA") {
              if (dsp.codeReseau !== "AI-DOUB") {
                statutElig = "Raccordé";
                codeStatut = "RA";
                iconColor = colorIcons.raccorde;
              } else {
                // overwrite statutEligibilite for DOUBS
                itemProps.statutEligibilite = "DE";
                statutElig = "Eligible";
                codeStatut = "EL";
                iconColor = colorIcons.deploye;
              }
            } else if (itemProps.statutEligibilite === "DE") {
              statutElig = "Eligible";
              codeStatut = "EL";
              iconColor = colorIcons.deploye;
            } else if (itemProps.statutEligibilite === "GE") {
              statutElig = "Prochainement éligible";
              codeStatut = "PE";
              iconColor = colorIcons.prochainementEligible;
            } else if (itemProps.statutEligibilite === "RD" && dsp.codeReseau !== "AI-JURA") {
              statutElig = "Raccordable sur demande";
              codeStatut = "RD";
              iconColor = colorIcons.demande;
            } else if (itemProps.statutEligibilite === "RDEC" && dsp.codeReseau !== "AI-JURA") {
              statutElig = "RAD en cours de déploiement";
              codeStatut = "RDEC";
              iconColor = colorIcons.demande;
            } else {
              // Valable pour : EC / SI / CI / ET
              statutElig = "En cours d'étude";
              codeStatut = "ET";
              iconColor = colorIcons.cible;

              // Gestion de la couleur ZA
              if (itemProps.ANNEE_COM === currentYear) zaColor = couleurZaDeploiement.ZaSroYearN0;
              else if (itemProps.ANNEE_COM === currentYear + 1)
                zaColor = couleurZaDeploiement.ZaSroYearN1;
              else if (itemProps.ANNEE_COM === currentYear + 2)
                zaColor = couleurZaDeploiement.ZaSroYearN2;
            }

            if (itemProps.etapeConstruction === "BLOC_COLLECTIF TIERS") {
              codeStatut = "BCT";
              iconColor = colorIcons.blocCollectifTiers;
            }

            let iconMap = "";
            let iconFa = "";

            if (codeStatut === "RA" && itemProps.gelCommercial === "0") {
              iconMap = IconAt;
              iconFa = faAt;
            } else if (itemProps.typeIMB === "P") {
              iconMap = IconPavillon;
              iconFa = faHouseChimney;
            } else {
              iconMap = IconImb;
              iconFa = faBuilding;
            }

            const marker = {
              key: itemProps.referenceIMB,
              position: [item.geometry.coordinates[1], item.geometry.coordinates[0]],
              iconMap: getIcon(iconMap, iconColor),
              iconFa: iconFa,
              iconColor: iconColor,
              codeStatut: codeStatut,
              typeIMB: itemProps.typeIMB,
              technoIMB: itemProps.technoIMB,
              referenceIMB: itemProps.referenceIMB,
              statutElig: statutElig,
              nomBatiment: itemProps.nomBatiment,
              numeroAdresse: `${itemProps.numeroAdresse}${itemProps.extensionAdresse}`,
              voieAdresse: itemProps.voieAdresse,
              codePostal: itemProps.codePostal,
              libelleCommune: itemProps.libelleCommune,
              anneeCom: itemProps.ANNEE_COM,
              zaColor: zaColor,
              gelCommercial: itemProps.gelCommercial,
              codeReseau: itemProps.codeReseau,
            };

            return marker;
          });

        setMarkersImmeubles(markersImmeublesTemp);
        setChargementIMBWtk(false);
      })
      .catch(e => {
        if (e.code !== "ERR_CANCELED") {
          setChargementIMBWtk(false);
          enqueueSnackbar(process.env.ERREUR_SERVEUR, {
            variant: "error",
            autoHideDuration: 6000,
          });
        }
      });
  };

  // Récupère l'icône de statut de l'immeuble
  const getIcon = (iconRDS, color) =>
    new DivIcon({
      html: iconRDS,
      className: `ai-icon`,
      style: {
        color: color,
        fontSize: "0.8em",
      },
      ...baseIcon,
    });

  useEffect(() => {
    if (displayMarkerImb && imbWkt.minLatLng && imbWkt.maxLatLng) {
      getImmeublesWTK(imbWkt.minLatLng, imbWkt.maxLatLng);
    }

    return () => abortImbWkt.abort();
  }, [imbWkt]);

  useEffect(() => () => abortImbWkt.abort(), []);

  return (
    <>
      {displayMarkerImb &&
        markersImmeubles.length > 0 &&
        markersImmeubles
          .filter(
            marker =>
              (optionSelectedConfigCarte.IMB_RAC && marker.codeStatut === "RA") ||
              (optionSelectedConfigCarte.IMB_ELIG && marker.codeStatut === "EL") ||
              (optionSelectedConfigCarte.IMB_PROELIG && marker.codeStatut === "PE") ||
              (optionSelectedConfigCarte.IMB_GELCOM && marker.codeStatut === "GE") ||
              (optionSelectedConfigCarte.IMB_ETUDE && marker.codeStatut === "ET") ||
              (optionSelectedConfigCarte.IMB_DEMANDE &&
                (marker.codeStatut === "RD" || marker.codeStatut === "RDEC")) ||
              (optionSelectedConfigCarte.IMB_BLOC_COLLECTIF_TIERS && marker.codeStatut === "BCT"),
          )
          .map(marker => (
            <Marker
              key={marker.key}
              position={marker.position}
              icon={marker.iconMap}
              codeStatut={marker.codeStatut}
              technoIMB={marker.technoIMB}
              statutElig={marker.statutElig}
              riseOnHover
            >
              <Popup
                minWidth={isMobileLandscape ? 360 : 260}
                maxWidth={isMobileLandscape ? 360 : 260}
                autoPan={false}
                key={marker.key + isMobileLandscape}
              >
                <div className={classNames("alignCenter", isMobileLandscape && "popup-ml")}>
                  <p className="popupTextContainer popupTitle" style={{ color: marker.iconColor }}>
                    {marker.codeStatut === "RA" && <span>Vous êtes raccordé à la fibre</span>}
                    {marker.codeStatut === "EL" && <span>Vous avez accès à la fibre</span>}
                    {(marker.codeStatut === "PE" ||
                      marker.codeStatut === "RD" ||
                      marker.codeStatut === "RDEC") && (
                      <span>Vous aurez prochainement accès à la fibre</span>
                    )}
                    {marker.codeStatut === "GE" ||
                      (marker.codeStatut === "BCT" && (
                        <span>L&apos;accès à la fibre est momentanément suspendu</span>
                      ))}
                    {marker.codeStatut === "ET" && (
                      <span>La fibre est en cours de déploiement</span>
                    )}
                    <span>
                      <a
                        className="picto-info-inline"
                        href={dsp.urlFibreSurDemande}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <FontAwesomeIcon className="info-logo" icon={faInfoCircle} size="1x" />
                      </a>
                    </span>
                  </p>
                  <div className="popupTextContainer infoContainer">
                    <p className="fontBold">
                      <span className="ai-icon-inline" style={{ color: marker.iconColor }}>
                        <FontAwesomeIcon icon={marker.iconFa} size="1x" />
                      </span>
                      <span>{marker.referenceIMB}</span>
                    </p>
                    <p className="adressContainer">
                      {marker.nomBatiment && <span>{marker.nomBatiment}, </span>}
                      <span>
                        {marker.numeroAdresse} {marker.voieAdresse},{" "}
                      </span>
                      <span>
                        {marker.codePostal} {marker.libelleCommune}
                      </span>
                    </p>
                  </div>
                  {marker.codeStatut === "BCT" && (
                    <>
                      <p>
                        Nous ne sommes pas en mesure de rendre votre logement éligible du fait d'un
                        refus de conventionnement syndic ou mairie. Merci de contacter votre{" "}
                        <strong>syndic</strong> dans le cadre d'une habitation collective OU votre{" "}
                        <strong>mairie</strong> pour plus d'informations.
                      </p>
                      <Button
                        className="markerButtonChangeAdresse"
                        href={dsp.urlChangementAdresse}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Je souhaite corriger mon adresse
                      </Button>
                    </>
                  )}
                  {(marker.codeStatut === "EL" ||
                    marker.codeStatut === "PE" ||
                    marker.codeStatut === "RD") && (
                    <>
                      <p className="popupTextContainer alignJustify">
                        Vous pouvez vous abonner auprès d&apos;un opérateur commercial,
                        l&apos;abonnement déclenchera votre raccordement au réseau.
                      </p>
                      <div className="buttonContainer">
                        <Button
                          className="markerButtonPrepare"
                          href={dsp.urlPreparation}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Je prépare l&apos;arrivée de la fibre
                        </Button>
                        <Button
                          className="markerButtonChangeAdresse"
                          href={dsp.urlChangementAdresse}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Je souhaite corrriger mon adresse
                        </Button>
                      </div>
                    </>
                  )}
                  <div>
                    <Button
                      className="markerButtonDetail"
                      onClick={() =>
                        onMarkerImbClick(marker.key, marker.position, marker.technoIMB)
                      }
                    >
                      Détails techniques du logement
                    </Button>
                  </div>
                </div>
              </Popup>
            </Marker>
          ))}
    </>
  );
};

MarkersImbFtth.propTypes = {
  dsp: propTypes.shape({
    logo: propTypes.string,
    codeMarche: propTypes.string,
    codeReseau: propTypes.string,
    libelle: propTypes.string,
    urlSite: propTypes.string,
    urlZonesDeploiement: propTypes.string,
    urlFibreFtth: propTypes.string,
    urlFibreSurDemande: propTypes.string,
    urlFibreFtte: propTypes.string,
    urlChangementAdresse: propTypes.string,
    urlListeOperateur: propTypes.string,
    urlPreparation: propTypes.string,
    secondaryMarches: propTypes.array,
  }).isRequired,
  imbWkt: propTypes.shape({
    minLatLng: propTypes.shape({
      lat: propTypes.number,
      lng: propTypes.number,
    }),
    maxLatLng: propTypes.shape({
      lat: propTypes.number,
      lng: propTypes.number,
    }),
  }).isRequired,
  marcheList: propTypes.array.isRequired,
  optionSelectedConfigCarte: propTypes.shape({
    LAYER_PLAN: propTypes.bool,
    LAYER_SAT: propTypes.bool,
    ALL_ZONES: propTypes.bool,
    SRO_DEP_201820: propTypes.bool,
    SRO_DEP_2021: propTypes.bool,
    SRO_DEP_2022: propTypes.bool,
    SRO_DEP_2023: propTypes.bool,
    SRO_OPEN: propTypes.bool,
    SRO_SOON: propTypes.bool,
    SRO_YEAR_N0: propTypes.bool,
    SRO_YEAR_N1: propTypes.bool,
    SRO_YEAR_N2: propTypes.bool,
    ZONE_RADIO: propTypes.bool,
    ZONE_AMII: propTypes.bool,
    ALL_STATUSES: propTypes.bool,
    IMB_RAC: propTypes.bool,
    IMB_ELIG: propTypes.bool,
    IMB_PROELIG: propTypes.bool,
    IMB_GELCOM: propTypes.bool,
    IMB_ETUDE: propTypes.bool,
    IMB_TRAVAUX_SECTEUR: propTypes.bool,
    IMB_TRAVAUX_RUE: propTypes.bool,
    IMB_DEMANDE: propTypes.bool,
    IMB_BLOC_COLLECTIF_TIERS: propTypes.bool,
    FTTE: propTypes.bool,
  }).isRequired,
  isMobileLandscape: propTypes.bool.isRequired,
  displayMarkerImb: propTypes.bool.isRequired,
  setChargementIMBWtk: propTypes.func.isRequired,
  onMarkerImbClick: propTypes.func.isRequired,
  onOperatorPopupClick: propTypes.func.isRequired,
  enqueueSnackbar: propTypes.func.isRequired,
};

export default compose(withSnackbar)(MarkersImbFtth);
